// Re-export the shared UrlConstants for backward compatibility
export * from '@/shared/UrlConstants';